<template>
    <div class="common-seach-wrap">
        <el-tabs size="small" type="card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.value" :name="item.key" ></el-tab-pane>
        </el-tabs>
        <List v-if="activeName === 'list'" />
        <Log :user="user_id" v-if="activeName === 'log'" />
    </div>
</template>
<script>
    import List from './course/index';
    import Log from './log/index';
    export default {
        components: {
            List,
            Log,
        },
        data() {
            return {
                user_id: 0,
                /*当前选中*/
                activeName: 'list',
                /*切换数组原始数据*/
                sourceList: [
                    {
                        key: 'list',
                        value: '课程管理',
                        path:'/education/course/index'
                    },
                    {
                        key: 'log',
                        value: '学习记录',
                        path:'/education/course/courseLog'
                    },
                ],
                /*权限筛选后的数据*/
                tabList:[],
            };
        },
        created() {
            this.tabList=this.authFilter();
            if (this.$route.query.type != null) {
                this.activeName = this.$route.query.type;
            }
            if(this.$route.query.user_id != null){
                this.user_id = parseInt(this.$route.query.user_id)
            }else {
                this.user_id = 0
            }
        },

        methods: {

            handleClick(e) {
                this.activeName = e.name;
            },

            /*权限过滤*/
            authFilter(){
                let list=[];
                for(let i=0;i<this.sourceList.length;i++){
                    let item=this.sourceList[i];
                    if(this.$filter.isAuth(item.path)){
                        list.push(item);
                    }
                }
                return list;
            },

        }
    };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/education/course/index.vue